export default __webpack_public_path__ + "static/media/product-app-3.82cb4c0e.png";